module.exports = __webpack_public_path__ + "static/media/as1tj54.83a4d8c8.png";